import { Grid } from '@material-ui/core';
import { Button, Card, Dialog, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { WorkPackageFilesDocument } from '../../rxdb/workPackageFiles/queryBuilder';
import useSelectedWorkPackageFile from '../../rxdb/workPackageFiles/useSelectedWorkPackageFile';
import WorkPackageFileDetails from './WorkPackageFileDetails';
import useStyles from './WorkPackageFiles.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  workPackageId: string;
}
const WorkPackageFiles: React.FC<Props> = ({ open, onClose, workPackageId }) => {
  const classes = useStyles();
  const { workPackageFiles } = useSelectedWorkPackageFile(workPackageId);
  return (
    <>
      <Dialog
        data-testid="work-package-files-dialog"
        onClose={onClose}
        fullScreen
        open={open}
        titleText={`Work Package Files (${workPackageFiles?.length})`}
        backButton={false}
        dialogActions={
          <Grid className={classes.actionDiv}>
            <Grid container justifyContent="flex-end" alignItems="center" className="actionGrid">
              <Grid item>
                <Button
                  data-testid="wp-files-dialog-close"
                  noMinHeight
                  color="primary"
                  variant="contained"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        }
        maxWidth="xs"
        noMinHeight
      >
        {workPackageFiles && workPackageFiles?.length > 0 ? (
          <Card elevation={1} className={classes.cardGrid}>
            {workPackageFiles?.map((val: WorkPackageFilesDocument) => {
              return <WorkPackageFileDetails data={val} />;
            })}
          </Card>
        ) : (
          <>
            <Typography className={classes.fileMessage}>
              No files added for this work package
            </Typography>
          </>
        )}
      </Dialog>
    </>
  );
};
export default observer(WorkPackageFiles);
